<template>
  <div
    v-if="x.totalResults"
    class="x-flex x-w-full x-flex-row x-items-center x-justify-between x-gap-16"
  >
    <div class="x-flex x-flex-auto x-items-center x-justify-end">
      <i18n-t
        class="x-text1 x-text1-lg x-flex-auto x-font-alternative x-text-neutral-90"
        keypath="totalResults.message"
        tag="span"
        scope="global"
        :plural="x.totalResults"
      >
        <template #totalResults>
          {{ x.totalResults }}
        </template>
        <template #query>
          <span class="x-title3">
            {{ x.spellcheckedQuery || query }}
          </span>
        </template>
      </i18n-t>

      <SortSelector />

      <BaseIdModalOpen
        modal-id="aside-modal"
        class="x-button-outlined x-ml-8 !x-min-h-32 x-rounded-full x-border-0 !x-border-lead-75 hover:x-border"
        data-test="toggle-facets-button"
      >
        <FilterIcon class="x-icon" />
        <span class="x-text1 x-text1-sm x-font-bold x-text-lead-75">{{
          $t('toggleAside.showAside')
        }}</span>
        <span
          v-if="x.selectedFilters.length"
          :class="{ 'x-badge-circle': x.selectedFilters.length <= 9 }"
          class="x-badge x-bg-lead-90"
        >
          {{ x.selectedFilters.length }}
        </span>
      </BaseIdModalOpen>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BaseIdModalOpen, use$x, useGetter } from '@empathyco/x-components'
import FilterIcon from '../icons/filter-icon.vue'
import SortSelector from '../search/sort-selector.vue'

const x = use$x()
const { query } = useGetter('search')
</script>
